<template>
  <div id="side-nav">
    <div id="side-header">
      <img id="mom-icon" class="img-fluid" src="../../static/images/mom-icon.png">
      <v-select :clearable="false" @search:focus="scrollToActive" label='name' value='id' placeholder='Select client' :on-change='setCurrentClient' class='select-no-caret' id="nav-select" v-model='currentClient' :options="clients" />
      <date-range-picker opens="right" :ranges="range" ref="picker" :startDate="startDate" :endDate="endDate" @update='updateDateRange'>
        <div slot="input" class="date-range-nav">
          <input type="text" class="borderless" id="startDate" v-model="startDate"> -
          <input type="text" class="borderless" id="endDate" v-model="endDate">
        </div>
      </date-range-picker>
      <b-form-checkbox v-on:change='toggleCompareDatesCheckbox' v-model="compareDatesCheckbox" value="true" unchecked-value="false" class="compare-checkbox">Compare</b-form-checkbox>
      <div v-if="compareDatesCheckbox === 'true'">
        <date-range-picker opens="right" :ranges="range" ref="comparePicker" :startDate="compareStartDate" :endDate="compareEndDate" @update='updateCompareDateRange'>
          <div slot="input" class="date-range-nav">
            <input type="text" class="borderless" id="compareStartDate" v-model="compareStartDate"> -
            <input type="text" class="borderless" id="compareEndDate" v-model="compareEndDate">
          </div>
        </date-range-picker>
        <div class="compare-row">
          <div class="compare-options" @click="previousMonth">Previous Month</div>
          <div class="compare-options" @click="previousYear">Previous Year</div>
        </div>
      </div>
    </div>
    <div id="side-wrapper">
      <div class="nav-header"><router-link to="/dashboards"><i class="fa fa-line-chart" aria-hidden="true"></i> DASHBOARDS</router-link></div>
      <div id="dashboard-sections" class="mt-2" v-if="this.$route.path.match(/dashboards\//)">
        <div class="nav-subheader">{{dashboard.name}}</div>
        <div v-if="sections.length > 0">
          <div :class="[section.id === sectionId ? 'active-section' : '', 'dash-item']" @click="$eventBus.$emit('navSection', section)" v-for="section in sections" :key="section.id">{{ section.name }}</div>
        </div>
      </div>
      <template v-if="currentUser.isDigital">
        <div v-b-toggle.collapse-admin class="nav-header"><i class="fa fa-cogs" aria-hidden="true"></i> ADMIN</div>
        <b-collapse id="collapse-admin" class="mt-2">
          <router-link to="/clients" class="nav-item">Clients</router-link>
          <router-link to="/client_groups" class="nav-item">Client Groups</router-link>
          <router-link to="/metrics" class="nav-item">Metrics</router-link>
          <router-link to="/import_data" class="nav-item">Import Data</router-link>
        </b-collapse>
      </template>
      <div v-b-toggle.collapse-user class="nav-header"><i class="fa fa-user" aria-hidden="true"></i> USER</div>
      <b-collapse id="collapse-user" class="mt-2">
        <div class="nav-item" v-if="signedAsName" v-b-tooltip.hover title="Logout as User" @click="logoutSignedAsUser"><i class="fa fa-user mr-2"/>Logged in as {{signedAsName}}</div>
        <router-link class="nav-item" to="/users" v-if="currentUser.isAgency">Manage Client Users</router-link>
        <router-link class="nav-item" v-if='currentUser.isAdmin' to='/switch_user'>Switch User</router-link>
        <router-link to="/reports" class="nav-item">My Reports</router-link>
        <a href="https://sokal.dealerview.net/" target="_blank" class="nav-item">Hamlin Results</a>
        <div class="nav-item" @click="logout">Logout</div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import { mapGetters } from 'vuex'
import Moment from 'moment'
import _ from 'lodash'
import axios from '../backend'

export default {
  components: {
    vSelect,
    DateRangePicker,
    Moment,
    axios
  },

  data () {
    return {
      compareDatesCheckbox: 'false',
      pdfButtonClass: 'fa-file-pdf-o',
      range: {
        'Today': [Moment(), Moment()],
        'Yesterday': [Moment().subtract(1, 'days'), Moment().subtract(1, 'days')],
        'This month': [Moment().startOf('month'), Moment()],
        'This year': [Moment().startOf('year'), Moment().endOf('year')],
        'Last week': [Moment().subtract(1, 'week').startOf('week'), Moment().subtract(1, 'week').endOf('week')],
        'Last month': [Moment().subtract(1, 'month').startOf('month'), Moment().subtract(1, 'month').endOf('month')],
        'Last 30 Days': [Moment().subtract(30, 'days'), Moment().subtract(1, 'day')],
        'Last 90 Days': [Moment().subtract(90, 'days'), Moment().subtract(1, 'day')],
        'Last year': [Moment().subtract(1, 'year').startOf('year'), Moment().subtract(1, 'year').endOf('year')]
      },
      users: [],
      signedAsName: null,
      sections: [],
      sectionId: null
    }
  },

  props: ['clients'],

  computed: {
    startDate: {
      get () {
        return this.$store.getters.startDate
      },
      set: _.debounce(function(value) {
        this.$store.commit('setStartDate', value)
      }, 1000)
    },
    endDate: {
      get () {
        return this.$store.getters.endDate
      },
      set: _.debounce(function(value) {
        this.$store.commit('setEndDate', value)
      }, 1000)
    },
    compareStartDate: {
      get () {
        return this.$store.getters.compareStartDate
      },
      set: _.debounce(function(value) {
        this.$store.commit('setCompareStartDate', value)
      }, 1000)
    },
    compareEndDate: {
      get () {
        return this.$store.getters.compareEndDate
      },
      set: _.debounce(function(value) {
        this.$store.commit('setCompareEndDate', value)
      }, 1000)
    },
    currentClient: {
      get () {
        return this.$store.getters.currentClient
      },
      set (clientObj) {
        this.$store.commit('setCurrentClient', clientObj)
      }
    },
    ...mapGetters(['currentUser', 'dashboard'])
  },

  methods: {
  setCurrentClient (clientObj) {
    if (this.currentClient && this.currentClient.id === clientObj.id) {
      return false;
    }
    this.$store.commit('setCurrentClient', clientObj)
    this.$eventBus.$emit('changeCurrentClient', clientObj)
    this.currentClient = this.$store.getters.currentClient
    },
    toggleCompareDatesCheckbox () {
      this.compareDatesCheckbox = (this.compareDatesCheckbox === 'true') ? 'false' : 'true'
      var startDate = null
      var endDate = null
      this.$eventBus.$emit('compareDatesEnabled', false)
      if (this.compareDatesCheckbox === 'true'){
        startDate = Moment(this.startDate, 'MMM DD, YYYY').subtract(1, 'month')
        endDate = Moment(this.endDate, 'MMM DD, YYYY').subtract(1, 'month')
        this.$eventBus.$emit('compareDatesEnabled', true)
      }
      this.$store.commit('setCompareStartDate', startDate)
      this.$store.commit('setCompareEndDate', endDate)
      this.$eventBus.$emit('reloadWidgets')
    },

    previousMonth () {
      var startDate = null
      var endDate = null
      startDate = Moment(this.startDate, 'MMM DD, YYYY').subtract(1, 'month')
      endDate = Moment(this.endDate, 'MMM DD, YYYY').subtract(1, 'month')
      this.$store.commit('setCompareStartDate', startDate)
      this.$store.commit('setCompareEndDate', endDate)
      this.$eventBus.$emit('reloadWidgets')
    },

    previousYear () {
      var startDate = null
      var endDate = null
      startDate = Moment(this.startDate, 'MMM DD, YYYY').subtract(1, 'year')
      endDate = Moment(this.endDate, 'MMM DD, YYYY').subtract(1, 'year')
      this.$store.commit('setCompareStartDate', startDate)
      this.$store.commit('setCompareEndDate', endDate)
      this.$eventBus.$emit('reloadWidgets')
    },

    scrollToActive () {
      const mouseoverEvent = new Event('mouseover');
      setTimeout(function(){
        var active = document.querySelectorAll('#nav-select .dropdown-menu .active')
        if (active.length > 0) {
          active[0].dispatchEvent(mouseoverEvent)
          active[0].scrollIntoView(true)
        }
      }, 100)
    },

    updateDateRange (dateRange) {
      this.$store.commit('setStartDate', dateRange.startDate)
      this.$store.commit('setEndDate', dateRange.endDate)
      this.$eventBus.$emit('reloadWidgets')
    },

    updateCompareDateRange (dateRange) {
      this.$store.commit('setCompareStartDate', dateRange.startDate)
      this.$store.commit('setCompareEndDate', dateRange.endDate)
    },
    updateSignedAsName () {
      var userId = axios.defaults.headers['SignAsUserId']
      if (userId){
        userId = parseInt(userId, 10)
        this.users.forEach(function(user){
          if (parseInt(user.id, 10) === userId){
            this.signedAsName = user.first_name + ' ' + user.last_name
          }
        }.bind(this))
      } else {
        this.signedAsName = null
      }
    },

    logout () {
      this.$store.commit('logout')
      this.$router.push('/login')
    },

    loadUsers () {
      this.$http.get('/users?switch_user=1')
        .then(function(response){
          this.users = response.data
        }.bind(this))
    },
    logoutSignedAsUser () {
      this.$router.go()
    }
  },

  created () {
    this.$eventBus.$on('switchUser', this.updateSignedAsName)
    this.$eventBus.$on('loadSections', (sections) => {
      this.sections = sections
    })
    this.$eventBus.$on('selectSection', (sectionId) => {
      this.sectionId = sectionId
    })
    this.loadUsers()
  },
  beforeDestroy () {
    this.$eventBus.$off('loadSections')
    this.$eventBus.$off('selectSection')
    this.$eventBus.$off('switchUser')
  }
}
</script>

<style scoped>
  .compare-row {
    color: #d1f0fa;
    margin-left: 25px;
    font-size: 10px;
  }
  .compare-options {
    width: 50%;
    display: inline-block;
    cursor: pointer;
  }
  #side-nav {
    font-family: 'Cooper Hewitt Medium';
    letter-spacing: 1px;
    width: 200px;
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#3796b4+0,307c94+100 */
    background: #3796b4; /* Old browsers */
    background: -moz-linear-gradient(left,  #3796b4 0%, #307c94 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left,  #3796b4 0%,#307c94 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right,  #3796b4 0%,#307c94 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3796b4', endColorstr='#307c94',GradientType=1 ); /* IE6-9 */
  }

  #mom-icon {
    width: 50px;
    padding: 10px;
    margin: 8px;
  }
  #startDate, #endDate, #compareEndDate, #compareStartDate {
    font-size: .8rem;
    font-family: "Cooper Hewitt Semibold";
    width: 100px;
    color: #d1f0fa;
    background: transparent;
    border: transparent;
    margin: 0 auto;
    text-align: center;
    text-transform: uppercase;
  }
  .compare-checkbox {
    font-size: .8rem;
    color: #d1f0fa;
    margin-left: 35px;
    text-transform: uppercase;
  }
  .date-range-nav {
    color: #d1f0fa;
  }
  .nav-item, .nav-header, .dash-item, .nav-header a {
    color: #fff;
    cursor: pointer;
    text-decoration: none;
  }
  .nav-header {
    margin-top: 20px;
    margin-left: 15px;
    font-family: "Cooper Hewitt Bold";
    letter-spacing: 2px;
  }
  .nav-subheader {
    margin-left: 30px;
    margin-bottom: 5px;
    color: #fff;
    font-family: "Cooper Hewitt Semibold";
  }
  .nav-item {
    margin-left: 20px;
    margin-bottom: 5px;
    padding-left: 10px;
    display: block;
    border-left: 2px solid rgba(255,255,255,0);
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
  }
  .dash-item {
    margin-left: 35px;
    margin-bottom: 5px;
    padding-left: 10px;
    border-left: 2px solid rgba(255,255,255,0);
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
  }
  .active-section, .router-link-exact-active {
    border-left: 2px solid rgba(255,255,255,.4);
    text-shadow: 2px 2px 7px rgba(0,0,0,.4);
  }
  #side-nav {
    position: fixed;
    z-index: 1019;
    width: 250px;
    height: 100vh;
  }
  #side-wrapper {
    overflow-y: scroll;
    height: calc(100% - 266px);
  }
  #side-wrapper::-webkit-scrollbar {
  display: none;
  }
  #side-wrapper {
  -ms-overflow-style: none;
  }
  #side-header {
    padding-bottom: 15px;
    border-bottom: 2px solid rgba(255,255,255,.2);
  }
</style>

<style>
  #side-nav div.form-control {
    background: transparent !important;
    border: none !important;
  }
  #nav-select {
    margin-top: 10px;
    margin-bottom: 15px;
    padding-top: 10px;
    padding-bottom: 5px;
    background-color: rgba(255,255,255,.2);
  }
  #nav-select .dropdown-toggle {
    border: none;
  }
  #nav-select .selected-tag {
    font-family: "Cooper Hewitt Bold";
    color: #fff;
    text-transform: uppercase;
    margin-left: 9px;
  }
  #nav-select i:before {
    border-color: #fff;
    margin-top: -3px;
  }
  .compare-checkbox .custom-control-label::after {
    top: .05rem;
    left: -1.55rem;
    display: block;
    width: 1rem;
    height: 1rem;
  }
  .compare-checkbox .custom-control-label::before {
    background: transparent;
    -webkit-box-shadow: 0px 0px 0px 1px rgba(255,255,255,1);
    -moz-box-shadow: 0px 0px 0px 1px rgba(255,255,255,1);
    box-shadow: 0px 0px 0px 1px rgba(255,255,255,1);
    height: .8rem;
    width: .8rem;
    border-radius: .125rem;
    top: .1rem;
  }
  .compare-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background: transparent;
  }
  #nav-select.v-select input[type=search] {
    color: #fff;
    height: 0;
  }
  #nav-select.v-select input[type=search]:focus {
    height: 30px;
  }
</style>
